import './styles.css';
import { parseRoute } from './router';
import { renderLandingView } from './ui/landing-view';
import { renderDesignPickerView } from './ui/design-picker-view';
import { renderBuilderView } from './ui/builder-view';
import { renderSalonBuilderView } from './ui/salon-builder-view';
import { renderAdminView } from './ui/admin-view';
import { renderDashboardView } from './ui/dashboard-view';
import { renderVoterView } from './ui/voter-view';
import { renderNotFoundView } from './ui/not-found-view';
import { clearCurrentBuild } from './current-build';

const app = document.getElementById('app');
if (!app) throw new Error('#app root not found');

const route = parseRoute(window.location.pathname);

switch (route.kind) {
  case 'landing':
    renderLandingView(app);
    break;
  case 'designs':
    renderDesignPickerView(app);
    break;
  case 'builder':
    // /new = expliziter Fresh-Start. Edit-Bindung lösen, damit der User
    // garantiert eine neue Umfrage anlegt — auch direkt nach Finalisierung
    // einer alten. Wer fortsetzen will, kommt über /admin oder das Dashboard.
    if (window.location.pathname === '/new') clearCurrentBuild();
    renderSalonBuilderView(app);
    break;
  case 'basic':
    // Klassische Werkbank-Optik — Fallback / Vergleichsbasis.
    if (window.location.pathname === '/basic') clearCurrentBuild();
    renderBuilderView(app);
    break;
  case 'admin':
    renderAdminView(app, route.token);
    break;
  case 'dashboard':
    renderDashboardView(app);
    break;
  case 'vote':
    renderVoterView(app, route.token);
    break;
  case 'embed':
    document.body.classList.add('embed-mode');
    renderVoterView(app, route.token);
    break;
  case 'not-found':
    renderNotFoundView(app);
    break;
}
